/**
 * TIR-EPD REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tirepd@iru.org
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TransportOperationStartCustomsOffice } from './transportOperationStartCustomsOffice';
import { TransportOperationTerminationCustomsOffice } from './transportOperationTerminationCustomsOffice';
import { SimpleLocation } from './simpleLocation';
import { TransportOperationMetadata } from './transportOperationMetadata';
import { DocumentReference } from './documentReference';
import { TransportOperationVehicleInformation } from './transportOperationVehicleInformation';


/**
 * Transport operation (transit or non-transit).
 */
export interface TransportOperation { 
    legId?: number;
    metadata?: TransportOperationMetadata;
    nonTransitLocation?: SimpleLocation;
    /**
     * Step reference, for non-transit only, else use stepReference in CustomsOffice(s)
     */
    nonTransitStepReference?: number;
    startCustomsOffice?: TransportOperationStartCustomsOffice;
    terminationCustomsOffice?: TransportOperationTerminationCustomsOffice;
    /**
     * Simplified compared to Code as the listURI would be always the same
     */
    movementCode?: string;
    /**
     * Simplified compared to Code as the listURI would be always the same ; for EAEU only (TransitFeatureCode)
     */
    goodsPurposeCode?: TransportOperation.GoodsPurposeCodeEnum;
    documentReferences?: Array<DocumentReference>;
    vehicles?: TransportOperationVehicleInformation;
}
export namespace TransportOperation {
    export type GoodsPurposeCodeEnum = 'other' | 'personal_use' | 'assistance';
    export const GoodsPurposeCodeEnum = {
        Other: 'other' as GoodsPurposeCodeEnum,
        PersonalUse: 'personal_use' as GoodsPurposeCodeEnum,
        Assistance: 'assistance' as GoodsPurposeCodeEnum
    };
}


